import React from "react";
import Slider from "react-slick";
import {AiOutlineRollback} from 'react-icons/ai';
import axios from "axios";
import {useToasts} from "react-toast-notifications";
import {useState}  from 'react';

const ComplementDetail = ({data, setIsShowItemID})=>{
    const { addToast } = useToasts();
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };
    const [wasAdded, setWasAdded] = useState(false);
    const items = ()=>{
        return data.fotos.map(i=>{
            return <div key={i.id_foto}><div className="dycComplementDetailSliderImage" style={{backgroundImage: `url(${i.url})`}}/></div>
        })
    }
    const handleAddCart = (id)=>{
        axios({
            url: '/api/add-cart',
            method: 'POST',
            data: {
                product: {
                    id: data.id_producto,
                    quantity: 1
                }
            }
        })
            .then(d=>{
            addToast(d.data.message, { appearance: 'success', autoDismiss: true });
                setWasAdded(true);
        })
            .catch(e=>{
                addToast('No se puedo agregar el producto a tu carrito, recarga la pagina e intenta de nuevo', { appearance: 'warning', autoDismiss: false });
            })
    };

    return <div className="dycComplementDetail">
        <div className="dycComplementDetailSlider">
            <Slider {...settings}>
                {items()}
            </Slider>
        </div>
        <h5>{data.nombre}</h5>
        <p className="dycComplementDetailPrice">${data.precio}MXN</p>
        <button disabled={wasAdded} className="button" onClick={()=>{handleAddCart(data.id_producto)}}>Agregar al carrito</button>
        <div className="dycComplementDetailBack" onClick={()=>{ setIsShowItemID(null) }}>
            <span><AiOutlineRollback/> Regresar a ver todos los productos</span>
        </div>
        <div className="dycComplementDetailDescription">
            <span>Descripción</span>
            { data?.descripcion && <div dangerouslySetInnerHTML={{__html: data.descripcion}}/> }
            { data?.comentarios && <div dangerouslySetInnerHTML={{__html: data.comentarios}}/> }
        </div>
    </div>
};

export default ComplementDetail;